module.exports = __webpack_public_path__ + "static/media/zipkin-logo.95e14668.png";